<template>
<div>

   <!-- Modal MESSAGE -->  
   <modalMessage ref="msgModal"/> 

<div class="jumbotron">


  <h1 class="display-4">FIDELITY CARD</h1>
  <p class="lead">{{ customer.first_name }} {{ customer.last_name }} - {{ customer.mobile }}</p>
  <hr class="my-4">

  <div>
  <form v-on:submit.prevent="FidelityAddCustomer()">
    <div class="form-row align-items-center">
      <div class="col-sm-3 my-1">
        <label class="sr-only" for="inlineFormInputGroupCard">NUMERO DI CARTA</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">NUMERO DI CARTA</div>
          </div>
          <input v-focus required type="number" class="form-control" id="inlineFormInputGroupCard" placeholder="Numero di carta" v-model="new_card">
        </div>
      </div>
      
      <div class="col-auto my-1">
        <button :disabled="spinner" type="submit" class="btn btn-primary">INVIA
         
        </button>
      </div>
    </div>
  </form>
  </div>


  <p v-if="response.PIEDE" class="lead">{{ response.PIEDE[0] }} SCADENZA CARTA : {{ response.SCADENZA_CARTA }} </p>
  
  <div class="d-flex justify-content-center gap-2 mt-3 ">
  <button v-if="response.PIEDE" @click="FidelitySendSMS()" type="button" class="btn btn-warning mr-4">
    INVIA SMS
  </button>

  <button v-if="response.PIEDE" @click="getGDPRuserConsents()" type="button" class="btn btn-info">
    VERIFICA CONSENSI
  </button>
</div>


  <li v-for="item in consensi">
    TIPO CONSENSO  {{ item.name }}
  </li>




</div>


</div>    
</template>
<script>
import axios          from 'axios'
import api            from '@/api'
import modalMessage   from '@/components/modalDialog/ModalMessage.vue'    
import { mapGetters } from 'vuex';


export default {
  props: ['customer'],
  components : {modalMessage},
  data () {
    return {    
      localCustomer : this.customer,
      new_card      : '',
      api_keys      : {},
      id_cliente    : 0,
      consensi      : [],
      response      : {},
      spinner       : false   
    }
  },

  computed: {
    ...mapGetters(['company','storeId']) 
  },


   directives: {
    focus: {
      // directive definition
      inserted: function(el) {                
        el.focus();
      }
    }
  },
async mounted()
    {   
        this.api_keys = await this.getBertiniFidelityApiKeys() 
    },
methods: 
{

  
  async getBertiniFidelityApiKeys()
  {
       
    const sp = 'spBertiniFidelityApiKeys'
    const payload = {sp}
      
    try{

        /*
        this.$refs.msgModal.show()   
        this.$refs.msgModal.setSpinner(true)
        */
       
        const res = await api.post(payload)

        if (res.status !== 200) 
        {
          throw new Error(res.data ||  res)
        }

        return res.data.recordsets[0][0]

             //await this.$refs.msgModal.show('TRASFERIMENTO ESEGUITO.',{'title':'MESSAGGIO'},4)
             //
    
          }

          catch (err) {
            
            this.$refs.msgModal.show(err.message,{},3)
            
          }
    },
  
    
  async createCustomerFidelityCard(card)
  {

    const card_number = card
    const companyId   = this.company.Id
    const customerId  = this.customer.customerId
    const sp          = 'spCreateCustomerFidelityCard'
    const payload     = {sp,card_number,companyId,customerId}
      
    try{

        /*
        this.$refs.msgModal.show()   
        this.$refs.msgModal.setSpinner(true)
        */
       
        const res = await api.post(payload)

        if (res.status !== 200) 
        {
          throw new Error(res.data ||  res)
        }

            

             //await this.$refs.msgModal.show('TRASFERIMENTO ESEGUITO.',{'title':'MESSAGGIO'},4)
             //
    
          }

          catch (err) {
            
            this.$refs.msgModal.show(err.message,{},3)
            
          }
    },
  

  createPayloadAddCustomer(apiKeys, method, blobData,card) {
  return {
    api_keys: {
      API_KEY            : apiKeys.API_KEY || "",
      HASH_KEY           : apiKeys.HASH_KEY || "",
      RSA_PUBLIC_KEY_MOD : apiKeys.RSA_PUBLIC_KEY_MOD || "",
      RSA_PUBLIC_KEY_EXP : apiKeys.RSA_PUBLIC_KEY_EXP || ""
    },
    method: method,
    data: {
      new_card : card,
      blobObject: {
        ...blobData
      }
      
    },
    
  };
},

createPayloadSendGDPR(apiKeys, card,tel) {
  return {
    api_keys: {
      API_KEY            : apiKeys.API_KEY || "",
      HASH_KEY           : apiKeys.HASH_KEY || "",
      RSA_PUBLIC_KEY_MOD : apiKeys.RSA_PUBLIC_KEY_MOD || "",
      RSA_PUBLIC_KEY_EXP : apiKeys.RSA_PUBLIC_KEY_EXP || ""
    },
    method :"sendGdprLinkSMS",
    
    data: {
      cod_carta : card,
      cellulare : tel
      
    },
    
  };
  },

  createPayloadGetCustomerId(apiKeys, card) {
  return {
    api_keys: {
      API_KEY            : apiKeys.API_KEY || "",
      HASH_KEY           : apiKeys.HASH_KEY || "",
      RSA_PUBLIC_KEY_MOD : apiKeys.RSA_PUBLIC_KEY_MOD || "",
      RSA_PUBLIC_KEY_EXP : apiKeys.RSA_PUBLIC_KEY_EXP || ""
    },
    method :"getID",
    
    data: {
      cod_carta : card,
      showData  : 'YES'
      
      
    },
    
  };
  },

  createPayloadGetGDPRuserConsents() {
  
  const apiKeys    = this.api_keys
  const id_cliente = this.id_cliente  
  return {
    api_keys: {
      API_KEY            : apiKeys.API_KEY || "",
      HASH_KEY           : apiKeys.HASH_KEY || "",
      RSA_PUBLIC_KEY_MOD : apiKeys.RSA_PUBLIC_KEY_MOD || "",
      RSA_PUBLIC_KEY_EXP : apiKeys.RSA_PUBLIC_KEY_EXP || ""
    },

    method :"getGDPRuserConsents",  
    data: {
      
      id_cliente : id_cliente,
                  
    },
    
  };
  },

  createPayloadBonus(apiKeys, card,cart) {
  return {
    api_keys: {
      API_KEY            : apiKeys.API_KEY || "",
      HASH_KEY           : apiKeys.HASH_KEY || "",
      RSA_PUBLIC_KEY_MOD : apiKeys.RSA_PUBLIC_KEY_MOD || "",
      RSA_PUBLIC_KEY_EXP : apiKeys.RSA_PUBLIC_KEY_EXP || ""
    },
    method :"loyaltyBonusRequest",
    
    
    data: {

      fidelity_card : card,
      references_list : cart
      
    },
    
  };
  },



 async FidelityAddCustomer()
  {         
            this.spinner = true
            this.$refs.msgModal.show()   
            this.$refs.msgModal.setSpinner(true)

            
            const nome          = this.customer.first_name
            const cognome       = this.customer.last_name
            const cellulare     = this.customer.mobile
            const email         = this.customer.mail || ''
            const new_card      = this.new_card
            
            const apiKeys  = this.api_keys
            const blobData = { nome: nome, cognome: cognome, cellulare: cellulare, email: email };
            const payload  = this.createPayloadAddCustomer(apiKeys, "cliente/aggiungi", blobData,new_card);            
            const url      =  "https://refapi3.cubapp.com/call"
                        
              axios({
              url    : url,
              method : "post",
              
              data   : payload
              }).then(async res =>  {
                  console.log('Response ',res)
                  const r = res.data && res.data.results && res.data.results.results;
                  const card  = r ? r.CARTA : null;
                  
                  if(card)
                  {
                    
                    this.response = {...r}               

                    // SQL DATA
                    this.createCustomerFidelityCard(card)

                    this.localCustomer.card = card                   
                    this.FidelitySendSMS() 
                    this.id_cliente = await this.FidelityGetCustomerId(card)  
                    this.new_card   = ''   
                    
                    this.$refs.msgModal.setSpinner(false)
                    const msg = 'ATTIVAZIONE CARTA EFFETTUATA.'
                    this.$refs.msgModal.show(msg,{'title':'ATTIVAZIONE CARTA'},5)
                    


                  }
                  else
                  {
                    if(res.data && res.data.error)
                    {
                      this.$refs.msgModal.setSpinner(false)
                      const msg = res.data.error === 'ErrorCardExists' ? "CARTA GIA' ATTIVATA." : res.data.error
                      this.$refs.msgModal.show(msg,{'title':'ATTENZIONE'},3)
                
                    }
                  }  
                  this.spinner = false
                  

              }).catch(err => {
                
                 console.log('Error response',err)
                 this.$refs.msgModal.show(err.message,{},3)
              })
                
  },


  
  async FidelitySendSMS()
  {         
            const apiKeys  = this.api_keys
            const tel      = this.localCustomer.mobile
            const card     = this.localCustomer.card           
            const payload  = this.createPayloadSendGDPR (apiKeys, card,tel);              
            const url      =  "https://api3.cubapp.com/call"
            
              axios({
              url    : url,
              method : "post",
              
              data   : payload
              }).then(res => {
                console.log('Response SEND SMS ',res)
              }).catch(err => {
                console.log('Error response SEND SMS',err)
              })
                
  },

  async FidelityGetCustomerId(card) {         
  
    const apiKeys = this.api_keys;
    const payload = this.createPayloadGetCustomerId(apiKeys, card);              
    const url     = "https://api3.cubapp.com/call";

  try {
    const res = await axios({
      url     : url,
      method  : "post",
      data    : payload
    });

    console.log('Response getID ', res);

    const r = res.data && res.data.results
    const id_cliente  = r ? r.id_cliente : null;

    return id_cliente; // ✅ ORA funziona
  } catch (err) {
      console.log('Error response getID', err);
    return 0;
  }
},


 async getGDPRuserConsents() {         

    this.consensi = []
    //const apiKeys = this.api_keys;
    const payload = this.createPayloadGetGDPRuserConsents();              
    const url     = "https://api3.cubapp.com/call";

  try {
    const res = await axios({
      url     : url,
      method  : "post",
      data    : payload
    });

    console.log('Response Consensi ', res);

    const r = res.data && res.data.results && res.data.results.consensi
    if(r)
    {
      this.consensi = r  
    }
    
    
  } catch (err) {
      console.log('Error response getID', err);
    
  }
},


async updateBonus(id_cliente,cart) {         
  
    const apiKeys = this.api_keys;
    const payload = this.createPayloadBonus(apiKeys, id_cliente,cart);              
    const url     = "https://refapi3.cubapp.com/call";

  try {
    const res = await axios({
      url     : url,
      method  : "post",
      data    : payload
    });

    console.log('Response BONUS ', res);
    
  } catch (err) {
      console.log('Error response BONUS', err);
    
  }
},
       
}
  
}
</script>

<style>

</style>